/**
 * Asynchronously loads the component for TestEditDecisionPopup page
 */

import { lazyLoad } from 'utils/loadable';

export const TestEditDecisionPopup = lazyLoad(
  () => import('./index'),
  module => module.TestEditDecisionPopup
);
